<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1 v-if="carrierSetting.id">
          {{ $t('editModel', { model: $tc('models.carrierSetting', 1) }) }}
        </h1>
        <h1 v-else>
          {{ $t('createModel', { model: $tc('models.carrierSetting', 1) }) }}
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-form @submit.prevent="submit">
          <v-card class="mt-4">
            <v-card-text>
              <v-container fluid grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="carrierSetting.key"
                                  v-if="!carrierSetting.id"
                                  name="key"
                                  :label="$t('attrs.key')"
                                  v-validate="'required'"
                                  :error-messages="errors.collect('key')"
                                  data-vv-name="key"
                                  :data-vv-as="$t('attrs.key')"
                                  required
                                  ></v-text-field>
                    <span v-if="carrierSetting.id">
                      <label for="">{{ $t('attrs.key') }}</label>
                      <h3>
                      {{ carrierSetting.key }}
                      </h3>
                    </span>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="carrierSetting.value"
                                  name="value"
                                  :label="$t('attrs.value')"
                                  v-validate="(carrierSetting.key == 'additional_info') ? '' : 'required'"
                                  :error-messages="errors.collect('value')"
                                  data-vv-name="value"
                                  :data-vv-as="$t('attrs.value')"
                                  required
                                  ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md12 v-if="labelFormat">
                    {{ $t('pExpressLabelFormat', {typeOne: 'letter size', typeTwo: '4X6'}) }}
                  </v-flex>

                  <v-flex xs12 sm12 md12 v-if="$auth.isDev()">
                    <v-checkbox v-model="carrierSetting.visible" :label="'Visible'"></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="back" :loading="loading" :disabled="loading">{{ $t('cancel') }}</v-btn>
              <v-btn color="primary" dark :loading="loading" :disabled="loading" type="submit">{{ $t('save') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CarrierSetting from '@/client/carrier-setting'
import Provider from '@/client/provider'

export default {
  name: 'CarrierSettingFormView',

  props: {},

  data () {
    return {
      loading: false,
      labelFormat: false,
      carrierSetting: {},
      freeze: false
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    async submit () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }

      this.loading = true
      try {
        await this.carrierSetting.save()
        this.setNotification({
          color: 'success',
          message: this.$t('successfullySavedNotification')
        })
        this.back()
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    },

    updateVisible () {
      this.carrierSetting.visible = !this.freeze
    },

    isAllow () {
      const isKey = this.carrierSetting.key == 'limit'
      const isDev = this.$auth.isDev()
      const isAdmin = this.$auth.isAdmin();
      const isMainAdmin = this.$auth.isMainAdmin();
      
      if (!isKey && !isDev && this.carrier.freeze_settings) {
        this.back()
      } else if (isKey && isAdmin && !isMainAdmin) {
        this.back() //limit main admin condition
      } else if (isKey && isAdmin && isMainAdmin && !this.carrierSetting.visible) {
        alert('no access')
        this.back() //limit main admin condition
      }
    }
  },

  watch: {
  },

  async mounted () {
    let provider = await Provider.all({where: {code: 'PExpress'}})

    const id = this.$route.params.id
    if (id) {
      this.carrierSetting = await CarrierSetting.findOne(id, { include: 'carrier' })
      this.freeze = !this.carrierSetting.visible

      if (provider.length > 0 && provider[0].id === this.carrierSetting.carrier.provider_id && this.carrierSetting.key === 'label_format') {
        this.labelFormat = true
      }
    }

    this.isAllow()
  }
}
</script>
